<div
    id="login"
    data-testid="t-login-div-1752672977568-9"
>
    <div
        class="authentication-wrapper"
        data-testid="t-login-div-1752672977568-8"
    >
        <div
            class="authentication-inner row"
            data-testid="t-login-div-1752672977568-7"
        >
            <!-- Side container -->
            <div
                class="d-none d-lg-flex col-lg-6 col-xl-7 col-xxl-8 align-items-center ui-bg-cover is-darkened"
                style="background-image: url('assets/img/login/AdobeStock_161230156.jpeg')"
                data-testid="t-login-div-1752672977568-2"
            >
                <!-- Text -->
                <div
                    class="text-white p-5"
                    data-testid="t-login-div-1752672977568-1"
                >
                    <h1
                        class="display-3"
                        [innerHTML]="'mws.welcometext' | i18n"
                        data-testid="t-login-h1-1752672977568-1"
                    ></h1>
                </div>
                <!-- /.Text -->
            </div>
            <!-- / Side container -->

            <!-- Form container -->
            <div
                class="col-lg-6 col-xl-5 col-xxl-4 align-self-center"
                data-testid="t-login-div-1752672977568-6"
            >
                <div
                    class="px-3 px-md-5 mx-auto"
                    style="max-width: 600px"
                    data-testid="t-login-div-1752672977568-5"
                >
                    <!-- Logo -->
                    <div
                        class="text-center"
                        style="margin-top: -80px"
                        data-testid="t-login-div-1752672977568-3"
                    >
                        <img
                            loading="lazy"
                            class="ui-w-80"
                            src="assets/img/logo_orgacard_mobile.svg"
                            alt
                            data-testid="t-login-img-1752672977568-1"
                        />
                    </div>

                    <!-- / Form -->
                    <div
                        class="content-box mt-4"
                        data-testid="t-login-div-1752672977568-4"
                    >
                        <oc-mws-systemlogin
                            [appSettings]="currentAppSettings"
                            [environment]="env"
                            (loginCallback)="doLogin($any($event))"
                            (authCallback)="setAuthToken($event)"
                            (showMessage)="doShowMessage($event)"
                            (loading)="doLoading($event)"
                            data-testid="t-login-oc-mws-systemlogin-1752672977568-1"
                        ></oc-mws-systemlogin>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div
    class="version p-2 flex-nowrap d-flex align-items-center"
    data-testid="t-login-div-1752672977568-10"
>
    <span
        class="d-inline-block"
        data-testid="t-login-span-1752672977568-1"
    >
        <!--         #BRANCH_NAME#-->
        {{ version }} ({{ ngVersion }}) / {{ env.applicationName }}</span
    >
    @if (!env.production) {
        <button
            class="ms-3 d-inline-block btn btn-success"
            routerLink="/dummy"
            data-testid="t-login-button-1752672977568-1"
        >
            HIER ZUM DUMMY
        </button>
    }
</div>
